import linkStyle from "@/lib/components/navigation/Header/navbar/linkStyle.shared";
import {
  NavbarMenuItemLinkType,
  useColorScheme,
  useHover,
  useIsActiveLink,
  useLocales,
} from "@/lib/main";
import { NavbarDropdownDirectionType } from "@/lib/types/navigation/header/navbar/NavbarMenuItem.type";
import { CSSProperties } from "react";
import { NavLink } from "react-router";

type Props = {
  direction: NavbarDropdownDirectionType;
  isHashLinks?: boolean;
  navbarMenuItem: NavbarMenuItemLinkType;
};

export default function NavbarMenuItemLink({
  direction,
  isHashLinks,
  navbarMenuItem,
}: Props) {
  const l = useLocales();
  const { colorScheme } = useColorScheme();
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();
  const isActive = useIsActiveLink(navbarMenuItem.to, isHashLinks);

  const navLinkStyle: CSSProperties = {
    ...linkStyle,
    color:
      isActive || isHovered
        ? "var(--color-text-link)"
        : "var(--color-text-primary)",
    backgroundColor: isHovered
      ? colorScheme === "dark"
        ? "var(--color-background-frame)"
        : "var(--color-background-canvas)"
      : "transparent",
    position: "relative",
    zIndex: "var(--z-index-header-navbar-menu-item-tab)",

    padding:
      direction === "down" ? "0 var(--spacing-md)" : "0 var(--spacing-lg)",
  };

  return (
    <NavLink
      className={() => (isActive ? "font-color-nav active" : "font-color-nav")}
      to={navbarMenuItem.to}
      style={navLinkStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {l(navbarMenuItem.title)}
    </NavLink>
  );
}
